import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./tile.scss";
import { getBackgroundCssFromRenditions } from "../../styles/CssInJsHelpers";

const Tile = ({ label, heading, backgroundImages, onClick, children, className, ...props }) => {
  const withBackground = !!backgroundImages && backgroundImages.length;

  const classes = classNames(
    "tile",
    {
      "tile--with-image": withBackground,
    },
    className
  );

  const handleKeyPress = e => {
    if (e.keyCode === 13) {
      onClick();
    }
  };

  let innerProps = {};
  if (onClick) {
    innerProps = {
      ...innerProps,
      onClick,
      role: "button",
      tabIndex: "0",
      onKeyDown: handleKeyPress,
    };
  }

  return (
    <div
      className={classes}
      {...innerProps}
      css={withBackground ? getBackgroundCssFromRenditions(backgroundImages) : {}}
      {...props}
    >
      {!!withBackground && <div className="tile__overlay" />}
      {children}
      <div className="tile__content">
        {label && <p className="tile__label">{label}</p>}
        <p className="tile__title u-font-heading u-content-container-medium">{heading}</p>
      </div>
    </div>
  );
};

Tile.propTypes = {
  /**
   * Component main title
   */
  heading: PropTypes.string.isRequired,
  /**
   * Label showing on top of the title
   */
  label: PropTypes.string,
  /**
   * Background image source
   */
  backgroundImages: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      minWidth: PropTypes.number,
      maxWidth: PropTypes.number,
    })
  ),
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

export default Tile;
